import { render, staticRenderFns } from "./FloatActionButton.vue?vue&type=template&id=153289fd&"
import script from "./FloatActionButton.vue?vue&type=script&lang=js&"
export * from "./FloatActionButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports